import type { MouseEvent, ReactElement, ReactNode } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import type { LeadPriorityScore } from "app/pages/sales-intelligence/domain/leads/types/lead-priority";
import leadsSearchFiltersI18nKeys from "app/pages/sales-intelligence/modules/leads-search-filters/utils/i18n";

type Props = {
    priority: LeadPriorityScore;
    children: ReactNode;
    onAddRule: (priority: LeadPriorityScore) => void;
};

export const LeadScoreDisabledTierTooltip = ({ priority, children, onAddRule }: Props): ReactElement => {
    const { translate } = useTranslate();

    const handleCtaClick = (event: MouseEvent) => {
        event.stopPropagation();
        onAddRule(priority);
    };

    return (
        <Tooltip
            placement="top"
            content={
                <Stack gap="4px">
                    <Text fontVariant="tooltip">
                        {translate(leadsSearchFiltersI18nKeys.leadScoresDisabledTierDescription(priority))}
                    </Text>
                    <Text
                        as="a"
                        onClick={handleCtaClick}
                        fontVariant="tooltip"
                        color={colorsPalettes.blue[300]}
                        cursor="pointer"
                    >
                        {translate(leadsSearchFiltersI18nKeys.leadScoresDisabledTierCta(priority))}
                    </Text>
                </Stack>
            }
        >
            {children}
        </Tooltip>
    );
};
